import { render, staticRenderFns } from "./ConsultNoteDetail.vue?vue&type=template&id=929f70b6&scoped=true"
import script from "./ConsultNoteDetail.vue?vue&type=script&lang=js"
export * from "./ConsultNoteDetail.vue?vue&type=script&lang=js"
import style0 from "./ConsultNoteDetail.vue?vue&type=style&index=0&id=929f70b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929f70b6",
  null
  
)

export default component.exports